/**
 * Created by augustocorvalan on 3/26/14.
 * UMD'ed by augustocorvalan on 4/16/14.
 */
'use strict';

var $ = require('dibs-jquery-shim');
var price = require('../global/mixins/commonjs/price');
var ContextProvider = require('../global/reactHelpers/ContextProvider');
var UserStore = require('../global/stores/UserStore.es');

/**
 * Initializes CurrencyLoader class
 * @param options
 * @param $el {obj} jQuery object of DOM region to be affected
 * @param userLoadOptions {obj} options to be passed in to dibs.user.load
 * @constructor
 */
function CurrencyLoader(options) {
    var self = this;
    var _defaults = {
        $el: null,
        userLoadOptions: {
            full: false,
            force: false,
        },
    };

    this.options = $.extend(_defaults, options);
    if (this.options.$el) {
        this.$el = this.options.$el;
    }

    if (this.$el) {
        ContextProvider.getContext().then(function(context) {
            var userStore = context.getStore(UserStore);
            userStore.addChangeListener(function(store) {
                self.setLocalizedPrices(store.state.currency);
            });
        });
    }
}

module.exports = CurrencyLoader;

$.extend(
    CurrencyLoader.prototype,
    {
        setLocalizedPrices: function(currency) {
            var self = this;
            var currentCurrency = self.getCurrentCurrency();

            if (currency !== currentCurrency || self.isHidden()) {
                self.updatePrices(true, currency);
                self.showLabels();
            }
        },
        loadLocalizedPrices: function() {
            var self = this;

            ContextProvider.getContext().then(function(context) {
                var userStore = context.getStore(UserStore);
                if (userStore.isCurrencyLoaded()) {
                    self.setLocalizedPrices(userStore.getCurrency());
                }
            });

            return;
        },
    },
    price
);



//////////////////
// WEBPACK FOOTER
// ./assets/js/user/CurrencyLocalization.js
// module id = 1074
// module chunks = 63